import { ReactFlowProvider } from '@xyflow/react'
import { type ReactNode } from 'react'
import '@xyflow/react/dist/base.css'

/** What a canvas needs around it from this engine: its store and its stylesheet. */
export function CanvasRoot({ children }: { children: ReactNode }) {
  return <ReactFlowProvider>{children}</ReactFlowProvider>
}
